import { createSlice} from '@reduxjs/toolkit';

const initialState = {
  limites: {
    id_uo: '',
    limites_deportes: 0,
    limites_casinos: 0,
    limites_casinos_vivo: 0,
    limites_poker: 0,
    limites_virtuales: 0,
    limites_hipicas: 0,
    minimo_deposito: 0,
    maximo_deposito: 0,
    tiempo_inactivo: 0,
    fecha_config: null
  }
};

const limitacionesSlice = createSlice({
  name: 'limitaciones',
  initialState,
  reducers: {
    setLimites: (state, action) => {
      state.limites.id_uo = action.payload.id_uo;
      state.limites.limites_deportes = action.payload.limites_deportes;
      state.limites.limites_casinos = action.payload.limites_casinos;
      state.limites.limites_casinos_vivo = action.payload.limites_casinos_vivo;
      state.limites.limites_poker = action.payload.limites_poker;
      state.limites.limites_virtuales = action.payload.limites_virtuales;
      state.limites.limites_hipicas = action.payload.limites_hipicas;
      state.limites.minimo_deposito = action.payload.minimo_deposito;
      state.limites.maximo_deposito = action.payload.maximo_deposito;
      state.limites.tiempo_inactivo = action.payload.tiempo_inactivo;
      state.limites.fecha_config = action.payload.fecha_config;
    },
    clearLimites: (state, action) => {
      state.limites.id_uo = 0;
      state.limites.limites_deportes = 0;
      state.limites.limites_casinos = 0;
      state.limites.limites_casinos_vivo = 0;
      state.limites.limites_poker = 0;
      state.limites.limites_virtuales = 0;
      state.limites.limites_hipicas = 0;
      state.limites.minimo_deposito = 0;
      state.limites.maximo_deposito = 0;
      state.limites.tiempo_inactivo = 0;
      state.limites.fecha_config = null;
    }
  },
});

export const {
  setLimites, 
  clearLimites
} = limitacionesSlice.actions;

export const selectLimites = (state) => state.limitaciones.limites;

export default limitacionesSlice.reducer;